/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import React from "react";
import PropTypes from "prop-types";

const UnsavedChangesDialog = ({ open, onCancel, onSave, saveDisabled = false }) => {
  if (!open) return null;

  return (
    <>
      {/* Backdrop */}
      <button
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 9998,
          border: "none",
          cursor: "default",
          width: "100%",
          height: "100%",
          padding: 0,
        }}
        onClick={onCancel}
        aria-label="Close dialog"
      />

      {/* Dialog */}
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#2C2C2C",
          color: "white",
          padding: "24px",
          borderRadius: "8px",
          zIndex: 9999,
          minWidth: "400px",
          maxWidth: "500px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
        }}
      >
        <h3
          style={{
            margin: "0 0 12px 0",
            fontSize: "18px",
            fontWeight: "600",
            color: "#FFFFFF",
          }}
        >
          Unsaved Changes!
        </h3>
        <p
          style={{
            margin: "0 0 8px 0",
            color: "#B8B8B8",
            fontSize: "14px",
            lineHeight: "1.4",
          }}
        >
          You have unsaved changes in the page!
        </p>
        <p
          style={{
            margin: "0 0 24px 0",
            color: "#B8B8B8",
            fontSize: "14px",
            lineHeight: "1.4",
          }}
        >
          Do you wish to save it?
        </p>
        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onCancel}
            style={{
              padding: "8px 16px",
              backgroundColor: "transparent",
              color: "#B8B8B8",
              border: "1px solid #5A5A5A",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              minWidth: "70px",
            }}
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            disabled={saveDisabled}
            style={{
              padding: "8px 16px",
              backgroundColor: saveDisabled ? "#6B6B6B" : "white",
              color: saveDisabled ? "#999999" : "#2C2C2C",
              border: "none",
              borderRadius: "6px",
              cursor: saveDisabled ? "not-allowed" : "pointer",
              fontWeight: "500",
              fontSize: "14px",
              minWidth: "100px",
              opacity: saveDisabled ? 0.6 : 1,
            }}
          >
            Save Changes
          </button>
        </div>
      </div>
    </>
  );
};

UnsavedChangesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saveDisabled: PropTypes.bool,
};

export default UnsavedChangesDialog;
